import type { CommentCommunication } from '@seen/core/models/communications/CommentCommunication'
import { StandardTask } from '@seen/core/models/tasks/standard/standardTask'
import { DotSeparator, TypographyDetail } from '@seen/ui'
import type { JSX } from 'react'
import { HoverDate } from '#src/components/core/hover-card/HoverDate.tsx'
import { HoverPractitioner } from '#src/components/core/hover-card/HoverPractitioner.tsx'
import { HoverTask } from '#src/components/HoverTask.tsx'
import { IconRelatedArrow } from '#src/components/icons/IconRelatedArrow.tsx'
import { useSearch } from '#src/hooks/useSearch.ts'

export interface CommentRelatedTasksProps {
  comment: CommentCommunication
}

export function CommentRelatedTasks({
  comment,
}: CommentRelatedTasksProps): JSX.Element | null {
  const { data: relatedTasks } = useSearch(StandardTask, {
    ...StandardTask.byBasedOn([comment.reference]),
    _sort: 'authored-on',
  })

  if (!relatedTasks?.length) {
    return null
  }

  return (
    <div className="mt-3 flex flex-col gap-1">
      {relatedTasks.map((task) => (
        <div key={task.id} className="flex items-start gap-1">
          <IconRelatedArrow className="size-4" />
          <TypographyDetail className="inline gap-1">
            <HoverPractitioner practitioner={task.author} />{' '}
            <span className="font-normal text-foreground-secondary">
              created task
            </span>
            &nbsp;
            <HoverTask task={task} />
            <span className="font-normal text-foreground-secondary">
              <DotSeparator />
              <HoverDate date={task.authoredOn} format="datetime" />
            </span>
          </TypographyDetail>
        </div>
      ))}
    </div>
  )
}
